// rest is mapped via rewrite in next config
export const APP_CONFIG_CONNECTION_STRING = process.env.APP_CONFIG_CONNECTION_STRING ?? '';

export const DATABASE_URL = process.env.DATABASE_URL ?? '';

export const AZURE_STORAGE_CONNECTION_STRING = process.env.AZURE_STORAGE_CONNECTION_STRING ?? '';

export const JWT_SECRET_KEY = process.env.JWT_SECRET_KEY ?? '';
export const JWT_ISSUER = process.env.JWT_ISSUER ?? '';

export const AAD_CLIENT_ID = process.env.AAD_CLIENT_ID ?? '';
export const AAD_CLIENT_SECRET = process.env.AAD_CLIENT_SECRET ?? '';
export const AAD_TENANT_ID = process.env.AAD_TENANT_ID ?? '';

export const MBAG_CLIENT_ID = process.env.MBAG_CLIENT_ID ?? '';
export const MBAG_SECRET_ID = process.env.MBAG_SECRET_ID ?? '';

export const OFFLINE_PASSWORD = process.env.OFFLINE_PASSWORD ?? '';

export const MINIO_ENDPOINT = process.env.MINIO_ENDPOINT ?? '';
export const MINIO_ROOT_USER = process.env.MINIO_ROOT_USER ?? '';
export const MINIO_ROOT_PASSWORD = process.env.MINIO_ROOT_PASSWORD ?? '';
/**
 * Debug variable - use for see manual control UI without robot
 */
export const REACT_APP_ROBOT_CONNECTED_TRUE =
  process.env.NEXT_PUBLIC_ROBOT_CONNECTED_TRUE === 'true' || false;

export const appVersion = process.env.NEXT_PUBLIC_VERSION ?? '0.0.0';
